module.exports = __webpack_public_path__ + "static/media/college_activity.b0dc4460.png";